import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import './UserPicks.css';

const UserPicks = () => {
  const { userId } = useParams();
  const [picks, setPicks] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    handleFetchUserPicks();
  }, [userId]);

  const handleFetchUserPicks = async () => {
    // TODO: Replace with actual API call
    try {
      setIsLoading(true);
      // TODO: 
      const response = await fetch(`https://ux97q9k5kb.execute-api.us-east-2.amazonaws.com/prod/picks/${userId}`);
      if (!response.ok) {
        throw new Error('Failed to fetch user picks')
      }
      const data = await response.json();
      const picks = typeof data === 'string' ? JSON.parse(data) : data;
      setPicks(picks)
      
    } catch (error) {
      console.error('Error fetching user picks:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="user-picks">
      <h1>OIM FANTASY 2025</h1>
    <h2>{userId}'s Picks</h2>

    {/* The Picks Header */}
    <div className="user-picks-table">
      {isLoading ? (
        <div className="loading-state" role="status" aria-live="polite">
          <div className="loading-spinner" />
          <span>Loading picks…</span>
        </div>
      ) : (
        <table>
          <thead>
            <tr>
              <th>Week</th>
              <th>Pick</th>
              <th>Odds</th>
              <th>Result</th>
            </tr>
          </thead>

          {/* The actual picks per OIM */}
          <tbody>
            {picks.map((pick, index) => (
              <tr key={index}>
                <td className="week">{pick.weekNum}</td>
                <td className="pick">{pick.pick}</td>
                <td className="odds">{pick.odds}</td>
                <td className="result">{pick.result}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  </div>
  );
};

export default UserPicks;